<div class="alert alert-{{ type() }}" role="alert">
  @if (icon) {
    <i class="fa fa-{{ icon }}"></i>
  }
  {{ message() }}
</div>
